<div class="info-dialog">
  <p-dialog [(visible)]="displayDialog"
            (visibleChange)="onVisibleChange($event)"
            [modal]="true"
            [dismissableMask]="true"
            appendTo="body"
            styleClass="si-dialog-small">
    <div>
      <div class="mb-3">
        <div class="info-dialog_title mb-3">{{dialogTitle | translate}}</div>
      </div>
      <div class="info-dialog_text">
        <div class="info-dialog_text_inbox-container">
          <div [innerHTML]="dialogText | translate"></div>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
